import { Component } from "@angular/core";

@Component({
	template: ` <ic-not-found [title]="'not_found.page' | translate" /> `,
	standalone: false,
})
export class RouteNotFoundComponent {}
